
import ValidationFormErrors from "@/Components/Forms/ValidationFormErrors.vue";
import Card from "@/Components/General/Card.vue";
import {useForm} from "@inertiajs/inertia-vue3";
import {defineComponent} from "@vue/runtime-core";
import Button from "@/Components/Buttons/Button.vue";
import route from "ziggy-js";
import Messages from "@/Components/General/Messages.vue";

export default defineComponent({
  components: {
    Card,
    ValidationFormErrors,
    Button,
    Messages,
  },
  props: {},
  setup() {



    return {
      route,
    };
  },
});
